module.exports = __webpack_public_path__ + "img/descer.ee69078c.svg";